import * as Actions from '../Actions/VincularOportunidadeActions';
import _ from '@lodash';
const initialState = {
    name: "Oportunidades",
    data: null,
    error: null,
    preload: false,
};

const VincularOportunidadeReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_OPORTUNIDADES:
            {
                return {
                    ...state,
                    data: action.payload,
                };
            }
        case Actions.OPORTUNIDADE_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                };
            }
        case Actions.OPORTUNIDADE_CHANGE_PRELOAD:
            {
                return {
                    ...state,
                    preload: !state.preload
                };
            }
        default:
            return state;
    }
};

export default VincularOportunidadeReducer;
